module.exports = __webpack_public_path__ + "static/andrew_skochylyas-7e6386d0d20ca961a6217d310d2d8716.png";